/**
 * Stable, IDREF-safe ids for the product details tablist. Tab values are
 * human-readable enum strings ("Delivery and returns"), and an id containing
 * whitespace is invalid HTML — `aria-controls` / `aria-labelledby` silently
 * stop resolving. Both ids derive from the same slug so a tab and its panel
 * always pair up, whichever template renders them.
 */
const toSlug = (value: string): string =>
	value
		.trim()
		.toLowerCase()
		.replace(/[^\p{L}\p{N}]+/gu, "-")
		.replace(/^-+|-+$/g, "");

export const getTabId = (value: string): string => `tab-${toSlug(value)}`;

export const getTabpanelId = (value: string): string =>
	`tabpanel-${toSlug(value)}`;

export const getAccordionButtonId = (value: string): string =>
	`accordion-${toSlug(value)}`;
